<template>
  <div class="common-header container clearfix">
    <div class="logo"></div>
    <div class="title" :title="title">{{ title }}</div>
  </div>
</template>
<script>
  export default {
    name: 'CommonHeader',
    props: {
      title: {
        type: String,
        default: ''
      }
    }
  }
</script>
